import { Location } from 'history'
import { matchPath, RouteProps } from 'react-router'
import {
  AccountBudgetHistoryMatchParams,
  accountHistoryRouteProps,
  BudgetBudgetHistoryMatchParams,
  budgetHistoryRouteProps,
  myWalletVirtualCardDetailRouteProps,
  VirtualCardDetailMatchParams,
  virtualCardDetailRouteProps,
} from 'src/navigation/routeProps'

type LocationWithPathname = Pick<Location, 'pathname'>
type RouteIdParams = { id?: string }

const getRouteId = <Params extends RouteIdParams>(
  backgroundLocation: LocationWithPathname,
  routeProps: RouteProps,
): string | undefined =>
  matchPath<Params>(backgroundLocation.pathname, routeProps)?.params.id

export const getBudgetHistoryCreditCardId = (
  backgroundLocation: LocationWithPathname,
): string | undefined =>
  getRouteId<BudgetBudgetHistoryMatchParams>(
    backgroundLocation,
    budgetHistoryRouteProps,
  )

export const getAccountHistoryCreditCardId = (
  backgroundLocation: LocationWithPathname,
): string | undefined =>
  getRouteId<AccountBudgetHistoryMatchParams>(
    backgroundLocation,
    accountHistoryRouteProps,
  )

export const getVirtualCardDetailId = (
  backgroundLocation: LocationWithPathname,
): string | undefined =>
  getRouteId<VirtualCardDetailMatchParams>(
    backgroundLocation,
    virtualCardDetailRouteProps,
  )

export const getMyWalletVirtualCardDetailId = (
  backgroundLocation: LocationWithPathname,
): string | undefined =>
  getRouteId<VirtualCardDetailMatchParams>(
    backgroundLocation,
    myWalletVirtualCardDetailRouteProps,
  )
